// Веб-обёртка над localStorage с TTL (замена AsyncStorage)

export const getItem = (key) => {
  try {
    return localStorage.getItem(key);
  } catch { return null; }
};

export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.error('Storage write error:', e);
  }
};

export const removeItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {}
};

export const getAllKeys = () => {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      keys.push(localStorage.key(i));
    }
    return keys;
  } catch { return []; }
};

export const multiRemove = (keys) => {
  keys.forEach(k => removeItem(k));
};

export const getWithExpiry = (key) => {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    const item = JSON.parse(itemStr);
    if (!item || typeof item.expiry !== 'number' || typeof item.value === 'undefined') {
      localStorage.removeItem(key);
      return null;
    }
    if (Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    try { localStorage.removeItem(key); } catch {}
    return null;
  }
};

export const setWithExpiry = (key, value, ttl = 7 * 24 * 60 * 60 * 1000) => {
  try {
    const maxTTL = 365 * 24 * 60 * 60 * 1000;
    const safeTTL = Math.min(ttl, maxTTL);
    const item = {
      value,
      expiry: Date.now() + safeTTL,
      cacheDate: new Date().toISOString(),
    };
    localStorage.setItem(key, JSON.stringify(item));
    return true;
  } catch {
    return false;
  }
};

export const clearAllCache = () => {
  try {
    localStorage.clear();
    return true;
  } catch { return false; }
};

export const getCacheStats = () => {
  try {
    const keys = getAllKeys();
    let totalSize = 0;
    keys.forEach(key => {
      const item = localStorage.getItem(key);
      if (item) totalSize += item.length;
    });
    return { totalKeys: keys.length, totalSize };
  } catch { return null; }
};
